import useSite from '../hooks/useSite';
import CarouselBuildingViews from '../components/CarouselBuildingViews';
import TableApartments from '../components/TableApartments';
import { MapViewer } from '../components/MapViewer';
import NavBar from './NavBar';
import { PanoramaViewer } from '../components/PanoramaViewer';
import { IframeViewer } from '../components/IframeViewer';

const Planner = () => {
  const [site] = useSite();

  if (!site?.siteid) {
    return <></>;
  }

  return (
    <div className="m-auto max-w-5xl">
      <NavBar />
      <div className="planner-wrapper relative">
        <MapViewer />
        <PanoramaViewer />
        <IframeViewer />
        <CarouselBuildingViews />
        <TableApartments />
      </div>
    </div>
  );
};

export default Planner;
